export const BUSINESS_IDENTIFIER = { ES_BAYTECA: 'ES_BAYTECA', AE_HUSPY: 'AE_HUSPY' } as const;

export const AUTH_METHOD = {
  email: 'email',
  sms: 'sms',
} as const;
export type AuthMethod = typeof AUTH_METHOD[keyof typeof AUTH_METHOD];
